import { render, staticRenderFns } from "./TenantSuccessPage.vue?vue&type=template&id=16155526"
import script from "./TenantSuccessPage.vue?vue&type=script&lang=js"
export * from "./TenantSuccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports